import { useCallback } from "react";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanName = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { name } = viewModel;

	const onSetName = useCallback(
		(input: string) => {
			onSetViewModel([{ key: "name", value: { ...name, value: input } }]);
		},
		[name, onSetViewModel],
	);

	return {
		name,
		onSetName,
	};
};
